import gtmData from '../config/gtmData.json';

const pushToDataLayer = value => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(gtmData[value]);
  console.log('Data pushed to dataLayer:', gtmData[value]);
};

export default pushToDataLayer;
